import {
  InputAdornment, Input,
} from '@material-ui/core';
import React from 'react';

interface BmiEntryProps {
  units?: string;
  name: string;
  value: string;
}

function BmiEntryControl(props: BmiEntryProps) : JSX.Element {
  const {
    units, name, value,
  } = props;

  return (
    <Input
      id={`text-entry-${name}`}
      endAdornment={units ?? <InputAdornment position="end">{units}</InputAdornment>}
      color="secondary"
      value={value}
      name={name}
      style={{
        width: '100px',
      }}
      readOnly
    />
  );
}

BmiEntryControl.defaultProps = {
  units: undefined,
};

export default BmiEntryControl;
